import type { StatusTone } from '../contracts/common';
import type { OfferContentField, OfferListFilter, OfferStatus, OfferVersionState } from '../contracts/offers';

/** Statusy oferty (MVP §8: robocza, do akceptacji właściciela, wysłana, przyjęta, odrzucona). */
export const OFFER_STATUS_LABELS: Record<OfferStatus, string> = {
  draft: 'Robocza',
  pending_owner: 'Do akceptacji właściciela',
  sent: 'Wysłana',
  accepted: 'Przyjęta',
  rejected: 'Odrzucona',
};

export const OFFER_STATUS_TONES: Record<OfferStatus, StatusTone> = {
  draft: 'neutral',
  pending_owner: 'accent',
  sent: 'warning',
  accepted: 'success',
  rejected: 'danger',
};

/** Pola treści oferty (formularz, podgląd wersji). */
export const OFFER_CONTENT_LABELS: Record<string, string> = {
  scope: 'Zakres',
  result: 'Rezultat',
  exclusions: 'Wyłączenia',
  assumptions: 'Założenia',
  estimatedSeconds: 'Szacowany czas',
  package: 'Pakiet godzin',
  rate: 'Stawka',
  timeline: 'Termin orientacyjny',
  terms: 'Warunki współpracy',
  examples: 'Przykłady',
};

/** Etykiety pól w porównaniu wersji (te same co w formularzu). */
export const OFFER_FIELD_LABELS: Record<OfferContentField, string> = {
  scope: 'Zakres',
  result: 'Rezultat',
  exclusions: 'Wyłączenia',
  assumptions: 'Założenia',
  estimatedSeconds: 'Szacowany czas',
  package: 'Pakiet godzin',
  rate: 'Stawka',
  timeline: 'Termin orientacyjny',
  terms: 'Warunki współpracy',
  examples: 'Przykłady',
};

/** Stan wersji (lista wersji w ofercie). */
export const OFFER_VERSION_STATE_LABELS: Record<OfferVersionState, string> = {
  draft: 'robocza',
  sent: 'wysłana',
  closed: 'zamknięta',
};

/** Zakładki listy ofert. */
export const OFFER_LIST_FILTER_LABELS: Record<OfferListFilter, string> = {
  open: 'Otwarte',
  accepted: 'Przyjęte',
  rejected: 'Odrzucone',
  all: 'Wszystkie',
};

/** Odmiana „oferta” (1 / 2–4 / 5+). */
export const OFFER_PLURAL_FORMS = ['oferta', 'oferty', 'ofert'] as const;
